import React, { useState } from 'react'
import injectSheet from 'react-jss/lib/injectSheet'
import classNames from 'classnames'

const imageStyles = {
  image: {
    opacity: '0',
    transition: 'opacity .4s ease-in'
  },
  loaded: {
    opacity: '1'
  }
}

export const Image = injectSheet(imageStyles)(
  ({ classes, className, ...props }) => {
    const [loaded, setLoaded] = useState(false)
    return (
      <img
        onLoad={() => setLoaded(true)}
        className={classNames(classes.image, className, {
          [classes.loaded]: loaded
        })}
        {...props}
      />
    )
  }
)
